import React ,{useState}from 'react'
import Navbar from '../navbar/navbar'
import ShopingCard from '../shopingCard/shopingCard'


import { motion } from 'framer-motion'
import Alert from '../alert/alert'
import MenuOptionHorizontal from '../navbar/menuOptionHorizotal'

const HomePage =(props)=>{
    // const [showAlert, setshowAlert] = useState(false);

    
    const [userData, setUserData] = useState({
        _id:'',
        name:'',
        lastName: '',
        email: '',
        phoneNumber:0,
        password:'',
        fotoAvatar:''
    })
    
    const updateDataUser=(dataU)=>{
        setUserData(dataU)
        props.updateUserData(dataU)
        localStorage.setItem("dataUser",JSON.stringify(dataU))
        
    }
    


    return(
        <div>
            {/* {JSON.stringify(userData)}
            {JSON.stringify(props.userData)} */}
            
            <Navbar updateDataUser={updateDataUser} userData={props.userData} dataTIENDA={props.dataTIENDA}></Navbar>
           

        </div>
    )
}

export default HomePage;